import { z } from "zod";
import { searchIntentSchema } from "../intent/search-intent.contract.ts";

export const searchSuggestionKindSchema = z.enum(["breed", "filter", "combo"]);
export const searchSuggestionSourceSchema = z.enum([
    "vocabulary",
    "curated",
    "llm",
]);

export const searchSuggestionRecordSchema = z
    .object({
        kind: searchSuggestionKindSchema,
        phrase: z.string().min(1),
        normalizedPhrase: z.string().min(1),
        intent: searchIntentSchema,
        weight: z.number(),
        listingCount: z.number().int().nonnegative(),
        source: searchSuggestionSourceSchema,
        generatorVersion: z.string().min(1),
        vocabularyVersion: z.string().min(1).nullable(),
        modelVersion: z.string().min(1).nullable(),
    })
    .strict();

export type SearchSuggestionKind = z.infer<typeof searchSuggestionKindSchema>;
export type SearchSuggestionSource = z.infer<
    typeof searchSuggestionSourceSchema
>;
export type SearchSuggestionRecord = z.infer<
    typeof searchSuggestionRecordSchema
>;
